const topFulBg = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let sec = document.querySelector('#jsSecFulBg');
    let wrap = sec.querySelector('.js-bg-wrap');
    let boxs = wrap.querySelectorAll('.js-bg-box');

    let trg = document.querySelectorAll('.js-sec-ful');

    trg.forEach((element, index) => {

      let tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: element,
          start: "-10% 110%",
          onEnter: () => boxs[index].classList.add('is-act'),
          // onLeave: () => console.log("onLeave"),
          // onEnterBack: () => console.log("onEnterBack"),
          onLeaveBack: () => boxs[index].classList.remove('is-act'),
          // markers: true,
        },
      })

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl.scrollTrigger.refresh()
        });
      });
      observer.observe(target);

    });



  }
})()
export default topFulBg;